import { render } from "./AvailablePaymentInInstallment.vue?vue&type=template&id=5983624d"
import script from "./AvailablePaymentInInstallment.vue?vue&type=script&lang=js"
export * from "./AvailablePaymentInInstallment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__